import { DesktopTimePicker, TabContext, TabList, TimePicker } from "@mui/lab";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ChangeEvent } from "react";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import CancelIcon from "@mui/icons-material/Cancel";
import galleryIcon from "./../../../../assets/icons/upload.png";
import plusIcon from "./../../../../assets/icons/plus.png";
import Cancel from "./../../../../assets/icons/close.png";
import AddEmpDialog from "./../../../restaurantsetup/components/AddEmployeeDialog/AddEmployeeDialog.tsx";

import TimingComponenet from "../../../components/TimingComponenet/TimingComponenet.tsx";
import SchedulerComponent from "../../../product/components/SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import axios from "axios";
import jwt_decode from "jwt-decode";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoadingView from "./../../../components/LoadingView/LoadingView.js";
import { uploadOneFiles } from "./../../../../fileUploader/SingleFileUploader.js";
import { getViewsGranularity } from "@mui/x-date-pickers/internals/utils/getDefaultReferenceDate.js";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import RestaurantTable from "../../../components/SpecificationTable/RestaurantTable.tsx";

import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AddFoodCategoryDialog from "../FoodCategory/AddfoodCategory.tsx";
import img1 from "../../../../assets/icons/user (1).png";
import AddressAddModal from "../AddressModal/AdressAddModal.jsx";
import {
  Autocomplete as GooglePlacesAutocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";
import { set } from "date-fns";
import { is } from "date-fns/locale";
import html2pdf from "html2pdf.js";

// Type definitions
interface ImageUploadState {
  selectedImages: string[];
}

function EditEmployeeDialog(props) {
  const [isChain, setisChain] = useState(false);
  const [phoneNumber, SetPhoneNumber] = useState();
  const [city, SetCity] = useState();
  const [validPhoneNumber, SetvalidPhoneNumber] = useState(true);
  const [email, setEmail] = useState();
  const [isvalidEmail, setIsValidEmail] = useState(true);
  const [emailErr, setEmailErr] = useState(false);
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [restaurantModalOpen, setRestaurantModalOpen] = useState(props.open);

  const [isHomeCookToggle, setIsHomeCookToggle] = useState(false);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState("Basic Collection");

  useEffect(() => {
    setRestaurantModalOpen(props.open);
  }, [props.open]);

  // To open address modal: close restaurant first
  const handleOpenAddressModal = () => {
    setRestaurantModalOpen(false); // Hide restaurant modal
    setShowAddressModal(true); // Show address modal
  };

  // To close address modal: restore restaurant modal
  const handleCloseAddressModal = () => {
    setShowAddressModal(false);
    setRestaurantModalOpen(true); // Reopen restaurant modal
  };

  // Add this handler function (before the return statement)
  const handleAddressSelect = (addressData) => {
    console.log("Selected address:", addressData);

    // Update the address field
    setSelectedAddress(addressData.address);
    setNewRestaurant((prev) => ({
      ...prev,
      AddressLine1: addressData.address,
      Latitude: addressData.latitude,
      Longitude: addressData.longitude,
    }));

    // Optionally, auto-fill PostCode if available
    const postcodeMatch = addressData.address.match(
      /[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}/i,
    );
    if (postcodeMatch) {
      setNewRestaurant((prev) => ({
        ...prev,
        PostCode: postcodeMatch[0],
      }));
    }
  };

  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const [newRestaurant, setNewRestaurant] = useState({
    id: "",
    Restaurantname: "",
    urlName: "",
    AddressLine1: "",
    Latitude: null,
    Longitude: null,
    AddressLine2: "",
    City: "",
    PostCode: "",
    Email: "",
    PhoneNumber: phoneNumber,
    // ProvidedFoodCategory: providedFoodDatas,
    isMemberOfChain: isChain,
    Details: "",
    ParentRestaurant: "",
    Logo: "",
    BakcgroundImage: "",
    PremisesImage: "",
    ServiceCahrge: "",
    HygeneRating: "",
    homePageTexts: [
      // {
      //     id: "string",
      //     restaurantId: "string",
      //     text: "string",
      //     isActive: true,
      //     rank: 0,
      //     creatorId: "string",
      //     creationDate: "2023-09-11T04:41:54.979Z",
      //     modifierId: "string",
      //     modificationDate: "2023-09-11T04:41:54.979Z"
      // }
    ],
    // CreatorId: tokenData.UserId,
  });
  console.log(newRestaurant);
  const [typewriterText, SettypewriterText] = React.useState("");
  const [typewriterTextList, SettypewriterTextList] = React.useState([]);
  const [temptypewriterTextList, SettemptypewriterTextList] = React.useState(
    [],
  );
  const [selectedtypewriterTextList, SetselectedtypewriterTextList] =
    React.useState([]);
  const [selectedTypewriter, setselectedTypewriter] = useState({});

  const validateEmail = (props) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidEmail(!emailPattern.test(props));
    return emailPattern.test(props);
  };
  const phoneNumberValue = (props) => {
    console.log(props);
    try {
      var test = props / 1;
      if (isNaN(test)) {
        var empty = "";
        SetvalidPhoneNumber(false);
        SetPhoneNumber(empty);
        newRestaurant.PhoneNumber = empty;
      } else {
        SetvalidPhoneNumber(true);
        SetPhoneNumber(props);
        newRestaurant.PhoneNumber = props;
      }
    } catch {
      console.log("Error");
    }
  };

  const handleAddItem = (AddSectionData) => {
    // setOpenAddSection(AddSectionData)
    console.log("object");
    setOpen(false);
  };

  //AddSpecification modal open functionality
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  });

  const [logoImg, setlogoImg] = useState<File[]>([]);

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      setlogoImg(filesToUpload);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  // console.log(state.selectedImages);

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    updatedImages.splice(index, 1);
    setState({ selectedImages: updatedImages });
  };

  const [BackgroundImagestate, setBackgroundImagestate] =
    useState<ImageUploadState>({ selectedImages: [] });
  const [backgroundImg, setbackgroundImg] = useState<File[]>([]);
  const handleBackgroundImageUpload = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - BackgroundImagestate.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      setbackgroundImg(filesToUpload);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [
              ...BackgroundImagestate.selectedImages,
              ...imagesArray,
            ];
            setBackgroundImagestate({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };
  const handleBackgroundDeleteImage = (index: number) => {
    const updatedImages = [...BackgroundImagestate.selectedImages];
    updatedImages.splice(index, 1);
    setBackgroundImagestate({ selectedImages: updatedImages });
  };

  const [PremisesImagestate, setPremisesImagestate] =
    useState<ImageUploadState>({
      selectedImages: [],
    });
  const [PremisesImg, setPremisesImg] = useState<File[]>([]);
  const [PremisesImgLoding, setPremisesImgLoding] = useState(true);

  const handlePremisesImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    console.log(files);
    console.log(PremisesImg);
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - PremisesImagestate.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);

      var obj = [...PremisesImg];

      obj.push(filesToUpload[0]);
      setPremisesImg(obj);

      console.log(obj);
      console.log(remainingSlots);
      // if (remainingSlots == 4 && PremisesImgLoding) {
      //     PremisesImagestate.selectedImages.pop();
      //     setPremisesImgLoding(false);
      // }

      console.log(PremisesImagestate.selectedImages);
      // imagesArray.length = 0;
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [
              ...PremisesImagestate.selectedImages,
              ...imagesArray,
            ];
            setPremisesImagestate({ selectedImages: updatedImages });
            console.log(PremisesImagestate.selectedImages);
          }
        };
        reader.readAsDataURL(file);
      }
      console.log(imagesArray);
    }
  };

  // console.log(PremisesImagestate.selectedImages);

  const handlePremisesDeleteImage = (index: number) => {
    const updatedImages = [...PremisesImagestate.selectedImages];
    updatedImages.splice(index, 1);
    PremisesImg.splice(index, 1);
    setPremisesImagestate({ selectedImages: updatedImages });
  };

  const handleClose = () => {
    props.onHandleAddItem(false);
    setopenConfirmaitonModal(false);
  };

  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const [Schedule, setSchedule] = React.useState([]);

  const getSchedule = (props) => {
    console.log(props);
    setSchedule(props);
  };

  const [LastOrderTime, setLastOrderTime] = React.useState([]);
  const [initialLastOrderTime, setInitialLastOrderTime] = React.useState([]);
  const getLastOrderTime = (props) => {
    console.log(props);
    setLastOrderTime(props);
  };

  const apiAddress = process.env.REACT_APP_SECRET;
  const [dataRows, setDataRows] = useState<any>();

  const [dataCollection, setDataCollection] = useState({});
  const [ManagerDatas, setManagerDatas] = useState<any[]>([]);

  const ParentRestaurant = JSON.parse(localStorage.getItem("parentrestaurant"));

  const loadManagerData = () => {
    axios
      .get(
        apiAddress +
          "/api/RestaurantUserMapper/GetAllEmployeeByParentRestaurant?restaurantId=" +
          ParentRestaurant.id,
      )
      .then((response) => {
        console.log(response.data);

        // Group data by user ID
        const groupedData = {};
        response.data.forEach((dt) => {
          if (!groupedData[dt.id]) {
            groupedData[dt.id] = {
              id: dt.id,
              fullName: dt.fullName,
              roles: [],
              restaurants: [],
            };
          }

          // Add role if not already present
          if (!groupedData[dt.id].roles.includes(dt.role)) {
            groupedData[dt.id].roles.push(dt.role);
          }

          // Add restaurant if not already present
          if (!groupedData[dt.id].restaurants.includes(dt.restaurantName)) {
            groupedData[dt.id].restaurants.push(dt.restaurantName);
          }
        });

        // Convert grouped data to list format
        var list: any[] = [];
        Object.values(groupedData).forEach((user: any) => {
          // Sort roles in priority order: SuperAdmin, GM, LocalManager
          const rolePriority = ["SuperAdmin", "GM", "LocalManager"];
          const sortedRoles = user.roles.sort((a: string, b: string) => {
            return rolePriority.indexOf(a) - rolePriority.indexOf(b);
          });

          // Group restaurants by role
          const restaurantsByRole = {};
          response.data.forEach((dt: any) => {
            if (dt.id === user.id) {
              if (!restaurantsByRole[dt.role]) {
                restaurantsByRole[dt.role] = [];
              }
              if (!restaurantsByRole[dt.role].includes(dt.restaurantName)) {
                restaurantsByRole[dt.role].push(dt.restaurantName);
              }
            }
          });

          // Create display text for restaurants by role
          const restaurantDisplay = sortedRoles
            .map((role) => {
              const restaurants = restaurantsByRole[role] || [];
              return restaurants.length > 0
                ? `${role}'s Restaurant${restaurants.length > 1 ? "s" : ""}: ${restaurants.join(", ")}`
                : "";
            })
            .filter((text) => text !== "")
            .join(" | ");

          var obj = {
            id: user.id,
            title: user.fullName,
            role: sortedRoles.join(", "), // Keep role for badge display
            restaurant: restaurantDisplay, // Grouped restaurants by role
            roles: sortedRoles,
            restaurants: user.restaurants,
            displayText: `${user.fullName}          ${sortedRoles.join(", ")}`,
            displayRestaurants: restaurantDisplay,
          };
          list.push(obj);
        });

        setManagerDatas(list);
      });
  };

  const loadData = async () => {
    await axios.get(apiAddress + "/api/FoodCategory/get").then((res) => {
      setsectionDatas(res.data);

      axios
        .get(
          apiAddress +
            "/api/Restaurant/getrestaurantdetailsbyidforedit/" +
            props.selectedId,
        )
        .then((response) => {
          SetloadingModal(false);
          var list = [];
          // list.push(response.data)
          // setRestaurantDatas(list);
          var obj = {
            id: response.data.id,
            restauranName: response.data.name,
            address: response.data.addressLine1,
            PhoneNumber: response.data.phoneNumber,
            Email: response.data.emailAddress,
          };
          newRestaurant.id = response.data.restaurantView.id;
          setreestaurantName(response.data.restaurantView.name);
          newRestaurant.Restaurantname = response.data.restaurantView.name;
          newRestaurant.AddressLine1 =
            response.data.restaurantView.addressLine1;
          newRestaurant.Latitude = response.data.restaurantView.latitude;
          newRestaurant.Longitude = response.data.restaurantView.longitude;
          newRestaurant.AddressLine2 =
            response.data.restaurantView.addressLine2;
          newRestaurant.City = response.data.restaurantView.city;
          newRestaurant.PhoneNumber = response.data.restaurantView.phoneNumber;
          // newRestaurant.Email = response.data.restaurantView.emailAddress;
          newRestaurant.urlName = response.data.restaurantView.urlName;
          newRestaurant.PostCode = response.data.restaurantView.postCode;
          newRestaurant.Details = response.data.restaurantView.details;
          newRestaurant.HygeneRating =
            response.data.restaurantView.hygieneRating;
          newRestaurant.ServiceCahrge =
            response.data.restaurantView.serviceCharge;
          var texts = response.data.typewriterTexts;
          console.log(texts);
          SettemptypewriterTextList(texts);
          SettypewriterTextList(texts);
          console.log(typewriterTextList);
          setEmail(response.data.restaurantView.emailAddress);
          SetPhoneNumber(response.data.restaurantView.phoneNumber);
          setDataRows(obj);

          setProvidedFoodDatas(response.data.foodcategories);
          setSchedule(response.data.schedulers);
          setLastOrderTime(response.data.schedulers.lastOrderTime);
          setInitialLastOrderTime(response.data.schedulers.lastOrderTime); // Store initial value

          setIsHomeCookToggle(response.data.restaurantView.isHomeCookToggle);
          setIsPreviewMode(response.data.restaurantView.isPreview);
          setSubscriptionPlan(response.data.restaurantView.subscriptionPlan);

          SettempspotifyLinkList(response.data.spotifyLinksViews);
          SetspotifyLinkList(response.data.spotifyLinksViews);

          SettempwebLinkList(response.data.webLinksViews);
          SetwebLinkList(response.data.webLinksViews);

          var logoImg: any[] = [];
          if (!!response.data.restaurantView.logoUrl) {
            logoImg.push(response.data.restaurantView.logoUrl);
          }

          state.selectedImages = logoImg;
          setlogoImg(logoImg);
          logoImg = [];

          if (!!response.data.restaurantView.backgroundImageUrl) {
            logoImg.push(response.data.restaurantView.backgroundImageUrl);
          }
          BackgroundImagestate.selectedImages = logoImg;
          setbackgroundImg(logoImg);
          var premisesImg: any[] = [];
          response.data.premisesImg.map((img, ind) => {
            premisesImg.push(img.title);
          });
          setPremisesImg(premisesImg);
          console.log(premisesImg);
          PremisesImagestate.selectedImages = premisesImg;

          setserviceCharge(response.data.restaurantView.serviceCharge);
          setHygieneRating(response.data.restaurantView.hygieneRating);
          setDetails(response.data.restaurantView.details);
          setDataCollection(response.data);
          setswitchCheck(response.data.restaurantView.isPetFriendly);
          setserviceChargeCompulsoryCheck(
            response.data.restaurantView.isServiceChargeCom,
          );
        });
    });
  };

  useEffect(() => {
    SetloadingModal(true);
    loadData();
    loadManagerData();
  }, []);

  useEffect(() => {
    if (isLoaded && inputRef.current && newRestaurant.AddressLine1) {
      const inputEl = inputRef.current;
      if (inputEl.value !== newRestaurant.AddressLine1) {
        inputEl.value = newRestaurant.AddressLine1;
        setSelectedAddress(newRestaurant.AddressLine1);
      }
    }
  }, [isLoaded, newRestaurant.AddressLine1]);

  useEffect(() => {
    if (dataCollection?.restaurantView?.isDelivery) {
      setDeliveryswitchCheck(dataCollection?.restaurantView?.isDelivery);
      setCollectionswitchCheck(
        dataCollection?.restaurantView?.isCollectionOnly,
      );
      setDeliveryOnlyswitchCheck(
        dataCollection?.restaurantView?.isDeliveryOnly,
      );
    }
    if (dataCollection?.restaurantView?.wifiSSID) {
      setwifiCheck(true);
      setwifiSSID(dataCollection?.restaurantView?.wifiSSID);
      setwifiPassWord(dataCollection?.restaurantView?.wifiPassword);

      if (dataCollection?.restaurantView?.wifiPassword == "") {
        setwifiPublicCheck(true);
      }
    }

    if (ManagerDatas) {
      var obj = ManagerDatas.find((x) => x.id == dataCollection?.gm?.id);
      console.log(obj);
    }
  }, [dataCollection]);
  console.log(dataCollection);
  const [defaultSection, setdefaultSection] = useState([]);
  const [sectionDatas, setsectionDatas] = useState([]);
  const [reestaurantName, setreestaurantName] = useState("");
  const [AddressLine2, setAddressLine2] = useState();
  const [providedFoodDatas, setProvidedFoodDatas] = useState([]);
  // Replace single manager state with multiple
  const [selectedManagers, setSelectedManagers] = useState<any[]>([]);
  // Track manager changes for API submission
  const [removedManagers, setRemovedManagers] = useState<any[]>([]);
  const [addedManagers, setAddedManagers] = useState<any[]>([]);
  const [originalManagers, setOriginalManagers] = useState<any[]>([]);
  // const addValue = (props) => {
  //   setSelectedManager(props);
  //   if (props == "") {
  //     setAutoCompleteValue({});
  //   } else {
  //     var obj = ManagerDatas.find((s) => s.title == props);
  //     setAutoCompleteValue(obj);
  //   }
  // };
  console.log(selectedManagers);
  console.log(removedManagers);

  // Handle manager removal - track removed managers for API
  const handleManagerRemove = (removedManager) => {
    // Check if this manager was originally present
    const wasOriginallyPresent = originalManagers.some(
      (original) => original.id === removedManager.id,
    );

    if (wasOriginallyPresent) {
      setRemovedManagers((prev) => [...prev, removedManager]);
    }
  };

  // Handle manager addition - track added managers for API
  const handleManagerAdd = (addedManager) => {
    // Check if this manager was not originally present
    const wasOriginallyPresent = originalManagers.some(
      (original) => original.id === addedManager.id,
    );

    if (!wasOriginallyPresent) {
      setAddedManagers((prev) => [...prev, addedManager]);
    }
  };

  // Handle manager selection change
  const handleManagerSelectionChange = (event, newValue) => {
    const previousManagers = selectedManagers;

    // Get current restaurant name
    const currentRestaurantName = newRestaurant.Restaurantname;
    console.log("Current restaurant name:", currentRestaurantName);

    // Check for managers with higher roles specifically for the current restaurant
    const invalidManagers = newValue.filter((manager) => {
      // Get the manager's role specifically for the current restaurant
      const currentRestaurantRole = manager.roles?.find((role, index) => {
        const higherRoles = ["Owner", "SuperAdmin", "Admin", "GM"];
        // Check if this role is a higher role AND if the corresponding restaurant matches current restaurant
        if (higherRoles.includes(role)) {
          const restaurantForThisRole = manager.restaurants?.[index];
          return (
            restaurantForThisRole &&
            restaurantForThisRole
              .toLowerCase()
              .includes(currentRestaurantName?.toLowerCase() || "")
          );
        }
        return false;
      });

      // Block if they have a higher role specifically for the current restaurant
      return currentRestaurantRole !== undefined;
    });

    if (invalidManagers.length > 0) {
      // Show toast message for invalid selections with specific roles
      const invalidManagerDetails = invalidManagers
        .map((manager) => {
          // Find the specific higher role for the current restaurant
          const currentRestaurantRole = manager.roles?.find((role, index) => {
            const higherRoles = ["Owner", "SuperAdmin", "Admin", "GM"];
            if (higherRoles.includes(role)) {
              const restaurantForThisRole = manager.restaurants?.[index];
              return (
                restaurantForThisRole &&
                restaurantForThisRole
                  .toLowerCase()
                  .includes(currentRestaurantName?.toLowerCase() || "")
              );
            }
            return false;
          });

          return `${manager.title} already has a ${currentRestaurantRole || "Unknown"} role`;
        })
        .join(", ");

      toast.error(
        `${invalidManagerDetails} for this restaurant. Please select other managers.`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        },
      );

      // Filter out invalid managers from the selection
      const validManagers = newValue.filter(
        (manager) => !invalidManagers.includes(manager),
      );
      setSelectedManagers(validManagers);

      // Update added/removed managers based on valid selection
      const removed = previousManagers.filter(
        (prev) => !validManagers.some((curr) => curr.id === prev.id),
      );

      const added = validManagers.filter(
        (curr) => !previousManagers.some((prev) => prev.id === curr.id),
      );

      removed.forEach((manager) => handleManagerRemove(manager));
      added.forEach((manager) => handleManagerAdd(manager));
    } else {
      // All selections are valid
      setSelectedManagers(newValue);

      // Find removed managers
      const removed = previousManagers.filter(
        (prev) => !newValue.some((curr) => curr.id === prev.id),
      );

      // Find added managers
      const added = newValue.filter(
        (curr) => !previousManagers.some((prev) => prev.id === curr.id),
      );

      // Update removed managers
      removed.forEach((manager) => handleManagerRemove(manager));

      // Update added managers
      added.forEach((manager) => handleManagerAdd(manager));
    }
  };

  const addProvidedFoodValue = (props) => {
    console.log(props);
    setProvidedFoodDatas(props);
  };

  const getDefaultValur = () => {
    var list = [];
    dataCollection.foodcategories.map((dt, index) => {
      var obj = sectionDatas.find((x) => x.id == dt.id);
      list.push(obj);
    });
    return list;
  };

  const submit = () => {
    console.log(PremisesImg);
    logoUpload();
  };

  const logoUpload = async () => {
    console.log(typeof logoImg[0]);
    var d = typeof logoImg[0];
    if (d == "string") {
      newRestaurant.Logo = logoImg[0];
      backgroundUpload();
    } else {
      const formData = new FormData();
      formData.append("file", logoImg[0]);
      console.log(object);
      await axios({
        method: "post",
        url: apiAddress + "/api/FileUpload/addfile",
        headers: {
          "Content-Type": "multipart/form-data", // <- HERE
        },
        data: formData,
      })
        .then((response) => {
          console.log(response);
          newRestaurant.Logo = response.data.url;
          backgroundUpload();
        })
        .catch((error) => {
          console.log(error);
          SetloadingModal(false);
        });
    }
  };
  const backgroundUpload = async () => {
    if (typeof backgroundImg[0] == "string") {
      newRestaurant.BakcgroundImage = backgroundImg[0];
      premisesUpload();
    } else {
      const formData = new FormData();
      formData.append("file", backgroundImg[0]);
      await axios({
        method: "post",
        url: apiAddress + "/api/FileUpload/addfile",
        headers: {
          "Content-Type": "multipart/form-data", // <- HERE
        },
        data: formData,
      })
        .then((response) => {
          console.log(response);
          newRestaurant.BakcgroundImage = response.data.url;
          premisesUpload();
        })
        .catch((error) => {
          console.log(error);
          SetloadingModal(false);
        });
    }
  };
  const premisesUpload = async () => {
    const formData = new FormData();
    PremisesImg.forEach((file) => {
      if (typeof file == "string") {
      } else {
        formData.append("file", file);
      }
    });
    console.log(formData);
  };

  const getBackgorundImgUrl = async (backImg) => {
    if (typeof backImg === "string" && backImg.startsWith("https://")) {
      newRestaurant.BakcgroundImage = backImg;
    } else {
      var backgroundImgRes = await uploadOneFiles(backImg);
      console.log("backgroundImgRes " + backgroundImgRes);
      newRestaurant.BakcgroundImage = backgroundImgRes[0];
    }
  };

  const getLogoImgUrl = async (logoImg) => {
    if (typeof logoImg === "string" && logoImg.startsWith("https://")) {
      newRestaurant.Logo = logoImg;
    } else {
      var logoImgRes = await uploadOneFiles(logoImg);
      console.log("logoImgRes " + logoImgRes);
      newRestaurant.Logo = logoImgRes[0];
    }
  };

  const getPremisesImgUrl = async (img) => {
    var premises = [];
    for (let i = 0; i < img.length; i++) {
      if (typeof img[i] === "string" && img[i].startsWith("https://")) {
        premises.push(img[i]);
      } else {
        var premisesRes = await uploadOneFiles(img[i]);
        console.log("premisesRes " + premisesRes);
        premises.push(premisesRes[0]);
      }
    }
    newRestaurant.PremisesImage = premises;
  };
  const [autoCompleteValue, setAutoCompleteValue] = useState();
  const [isYes, setIsYes] = useState(false);
  const [sweetAlertopen, setsweetAlertopen] = useState(false);

  const handleOnYes = () => {
    setIsYes(true);
  };
  const [tokenData, setTokenData] = useState();

  const postData = async () => {
    var valid = true;
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        setTokenData(decodedData);
        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
        var list = [];
        list.push(obj);
        setManagerDatas(list);
      } catch (error) {}
    }

    // Email Validation
    if (email.trim() === "") {
      setEmailErr(true);
    } else {
      if (!validateEmail(email)) {
        valid = false;
        toast.error("Email is not valid", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }

    var listOfTypewriterTexts = [];
    if (selectedtypewriterTextList.length == 0) {
      valid = false;
      toast.error("Typewriter list is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      selectedtypewriterTextList.map((dt, i) => {
        var obj = {
          id: "string",
          restaurantId: "string",
          text: dt.name,
          isActive: true,
          rank: dt.rank,
          creatorId: decodedData.UserId,
          creationDate: "2023-09-11T04:41:54.979Z",
          modifierId: decodedData.UserId,
          modificationDate: "2023-09-11T04:41:54.979Z",
        };
        listOfTypewriterTexts.push(obj);
        newRestaurant.homePageTexts = listOfTypewriterTexts;
      });
    }

    await getBackgorundImgUrl(backgroundImg[0]);
    await getLogoImgUrl(logoImg[0]);
    await getPremisesImgUrl(PremisesImg);

    // newRestaurant.BakcgroundImage = backgroundImg[0]
    // newRestaurant.Logo = logoImg[0]
    // newRestaurant.PremisesImage = PremisesImg;

    newRestaurant.providedFoodCategories = providedFoodDatas;
    newRestaurant.scheduler = Schedule;
    newRestaurant.lastOrderTimes = LastOrderTime ?? [];
    newRestaurant.managerName = selectedManagers;
    // Add manager changes tracking
    newRestaurant.addedManagers = addedManagers;
    newRestaurant.removedManager = removedManagers;
    newRestaurant.CreatorId = decodedData.UserId;
    newRestaurant.Email = email;
    newRestaurant.City =
      city === null || city === undefined ? newRestaurant.City : city;
    newRestaurant.PhoneNumber = phoneNumber;

    newRestaurant.isDelivery = DeliveryswitchCheck;
    newRestaurant.isCollectionOnly = CollectionswitchCheck;
    newRestaurant.isDeliveryOnly = DeliveryOnlyswitchCheck;
    newRestaurant.wifiSSID = wifiSSID;
    newRestaurant.wifiPassword = wifiPassWord;
    newRestaurant.isPetFriendly = switchCheck;
    newRestaurant.isServiceChargeCompulsory = serviceChargeCompulsoryCheck;

    // spotify payload prepration
    let spotifylist = [];
    selectedSpotifyLinksList.map((dt, i) => {
      var obj = {
        id: "string",
        restaurantId: "string",
        text: dt.name,
        creatorId: decodedData.UserId,
      };

      spotifylist.push(obj);
    });
    newRestaurant.spotifyLinks = spotifylist ?? [];

    // WebLink payload prepration
    let weblinklist = [];
    selectedWebLinksList.map((dt, i) => {
      var obj = {
        id: "string",
        restaurantId: "string",
        text: dt.name,
        creatorId: decodedData.UserId,
      };
      weblinklist.push(obj);
    });
    newRestaurant.webLinks = weblinklist ?? [];

    // if (
    //   !LastOrderTime || // Check if it is empty or undefined
    //   LastOrderTime.some((time) => time === null ) // Ensure no empty time entries
    // ) {
    //   valid = false;
    //   toast.error("Please confirm Last Order Time again", {  position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",});
    // }

    if (
      phoneNumber == "" ||
      phoneNumber == undefined ||
      phoneNumber == null ||
      (phoneNumber.length !== 10 && phoneNumber.length !== 11)
    ) {
      valid = false;
      toast.error("Phone number is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (
      newRestaurant.Email == "" ||
      newRestaurant.Email == undefined ||
      newRestaurant.Email == null ||
      !newRestaurant.Email.includes("@")
    ) {
      valid = false;
      toast.error("Email is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (
      email.trim() == "" ||
      providedFoodDatas.length == 0 ||
      Schedule.length == 0 ||
      details.trim() == ""
    ) {
      valid = false;
      toast.error("one or more field is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (
      newRestaurant.City == "" ||
      newRestaurant.City == undefined ||
      newRestaurant.City == null
    ) {
      valid = false;
      toast.error("City field is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    console.log("Manager Changes:", {
      selectedManagers,
      addedManagers,
      removedManagers,
      originalManagers,
    });
    console.log(newRestaurant);

    await handleOnYes();
    if (valid) {
      SetloadingModal(true);
      await axios({
        method: "put",
        url:
          apiAddress + "/api/Restaurant/updaterestaurant/" + newRestaurant.id,
        data: newRestaurant,
      })
        .then((response) => {
          console.log(response);
          var obj = {
            Restaurantname: "",
            AddressLine1: "",
            AddressLine2: "",
            City: "",
            PostCode: "",
            Email: "",
            PhoneNumber: "",
            ProvidedFoodCategory: "",
            isMemberOfChain: "",
            Details: "",
            ParentRestaurant: "",
            Logo: "",
            BakcgroundImage: "",
            PremisesImage: "",
            ServiceCahrge: "",
            HygeneRating: "",
            CreatorId: decodedData.UserId,
          };
          setNewRestaurant(obj);
          setProvidedFoodDatas([]);
          setSchedule([]);
          setLastOrderTime([]);

          setAutoCompleteValue([]);
          SetloadingModal(false);
          toast.success("Successfully updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          window.location.href = "/restaurant-setup";
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          SetloadingModal(false);
          toast.error(error, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const [serviceCharge, setserviceCharge] = useState("");
  const [hygieneRating, setHygieneRating] = useState("");
  const [details, setDetails] = useState("");
  const [isEdit, setisEdit] = useState(false);

  useEffect(() => {
    SettypewriterTextList(temptypewriterTextList);
  }, [typewriterTextList]);

  const addtoTypewriterList = () => {
    if (isEdit) {
      typewriterTextList.map((dt, i) => {
        if (dt.id == selectedTypewriter.id) {
          dt.text = typewriterText;
        }
      });
      var list = typewriterTextList;
      SettemptypewriterTextList(list);
      SettypewriterTextList([]);
      SettypewriterText("");
      setisEdit(false);
    } else {
      var obj = {
        id: typewriterTextList.length,
        text: typewriterText,
      };
      var list = typewriterTextList;
      list.push(obj);
      SettemptypewriterTextList(list);
      SettypewriterTextList([]);
      SettypewriterText("");
    }
  };

  const getTypeWriterData = (props) => {
    SetselectedtypewriterTextList(props);
  };

  const editRow = (row) => {
    SettypewriterText(row.name);
    setselectedTypewriter(row);
    setisEdit(true);
  };
  const deleteRow = (row) => {
    var obj = typewriterTextList.find((x) => x.id == row.id);
    var index = typewriterTextList.indexOf(obj);
    var spliceData = typewriterTextList.splice(index, 1);
    SettemptypewriterTextList(typewriterTextList);
    SettypewriterTextList([]);
  };

  const [DeliveryswitchCheck, setDeliveryswitchCheck] = useState(false);
  const [CollectionswitchCheck, setCollectionswitchCheck] = useState(false);
  const [DeliveryOnlyswitchCheck, setDeliveryOnlyswitchCheck] = useState(false);
  const [CollectionDisabled, setCollectionDisabled] = useState(true);

  const handleDeliverySwitchChange = (props) => {
    if (DeliveryswitchCheck == false) {
      setDeliveryswitchCheck(true);
      //setCollectionswitchCheck(true)
    } else {
      setDeliveryswitchCheck(false);
      //setCollectionswitchCheck(false)
    }
  };

  const handleDeliveryOnlySwitchChange = (props) => {
    if (DeliveryOnlyswitchCheck == false) {
      setDeliveryOnlyswitchCheck(true);
      //setCollectionswitchCheck(true)
    } else {
      setDeliveryOnlyswitchCheck(false);
      //setCollectionswitchCheck(false)
    }
  };

  const handleCollectionSwitchChange = (props) => {
    if (CollectionswitchCheck == false) {
      //setDeliveryswitchCheck(true)
      setCollectionswitchCheck(true);
    } else {
      //setDeliveryswitchCheck(false)
      setCollectionswitchCheck(false);
    }
  };

  const [wifiCheck, setwifiCheck] = useState(false);
  const [wifiPublicCheck, setwifiPublicCheck] = useState(false);
  const [wifiSSID, setwifiSSID] = useState("");
  const [wifiPassWord, setwifiPassWord] = useState("");

  const handleWifiCheck = (props) => {
    if (wifiCheck == false) {
      setwifiCheck(true);
    } else {
      setwifiCheck(false);
      setwifiSSID("");
      setwifiPassWord("");
    }
  };
  const handleWifiPublicCheck = (props) => {
    if (wifiPublicCheck == false) {
      setwifiPublicCheck(true);
    } else {
      setwifiPublicCheck(false);
    }
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  //#region Spotify link functionlities
  const [spotifyLink, SetspotifyLink] = React.useState("");
  const [spotifyLinkList, SetspotifyLinkList] = React.useState([]);
  const [tempspotifyLinkList, SettempspotifyLinkList] = React.useState([]);
  const [selectedSpotifyLink, setsselectedSpotifyLink] = useState({});

  const addtoSpotifyLinksList = () => {
    // var obj = {
    //   name: spotifyLink,
    // };
    // var list = spotifyLinkList;
    // list.push(obj);
    // SettempspotifyLinkList(list);
    // SetspotifyLinkList([]);
    // SetspotifyLink("");

    if (isEdit) {
      spotifyLinkList.map((dt, i) => {
        if (dt.id == selectedSpotifyLink.id) {
          dt.text = spotifyLink;
        }
      });
      var list = spotifyLinkList;
      SettempspotifyLinkList(list);
      SetspotifyLinkList([]);
      SetspotifyLink("");
      setisEdit(false);
    } else {
      var obj = {
        id: spotifyLinkList.length,
        text: spotifyLink,
      };
      var list = spotifyLinkList;
      list.push(obj);
      SettempspotifyLinkList(list);
      SetspotifyLinkList([]);
      SetspotifyLink("");
    }
  };

  useEffect(() => {
    SetspotifyLinkList(tempspotifyLinkList);
  }, [spotifyLinkList]);

  const [selectedSpotifyLinksList, SetselectedSpotifyLinksList] =
    React.useState([]);

  const getSpotifyData = (props) => {
    SetselectedSpotifyLinksList(props);
  };

  // useEffect(() => {
  //   console.log(selectedSpotifyLinksList)
  // }, [selectedSpotifyLinksList]);

  //#endregion

  const [openAddSection, setOpenAddSection] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOpenFoodCategory = (AddSectionData) => {
    setOpenAddSection(AddSectionData);
    // loadData();
  };

  //#region Web link functionlities

  const [webLink, SetWebLink] = React.useState("");
  const [webLinkList, SetwebLinkList] = React.useState([]);
  const [tempWebLinkList, SetTempWebLinkList] = React.useState([]);
  const [selectedWebLinksList, SetselectedWebLinksList] = React.useState([]);
  const [tempwebLinkList, SettempwebLinkList] = React.useState([]);

  useEffect(() => {
    SetwebLinkList(tempwebLinkList);
  }, [webLinkList]);

  const getWebLinkData = (props) => {
    SetselectedWebLinksList(props);
    SetwebLinkList(props);
  };

  const addWebLink = () => {
    // urlValidation
    const urlPattern =
      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})(\/[\w \.-]*)*\/?$/;
    if (!urlPattern.test(webLink)) {
      toast.error("Please enter a valid URL.");
      return;
    }

    if (isEdit) {
      webLinkList.map((dt, i) => {
        if (dt.id == selectedSpotifyLink.id) {
          dt.text = spotifyLink;
        }
      });

      var list = spotifyLinkList;
      SettempspotifyLinkList(list);
      SetspotifyLinkList([]);
      SetspotifyLink("");
      setisEdit(false);
    } else {
      var obj = {
        id: webLinkList.length,
        text: webLink,
      };

      var list = webLinkList;

      list.push(obj);

      SettempwebLinkList(list);
      SetwebLinkList([]);
      SetWebLink("");
    }
  };
  const [switchCheck, setswitchCheck] = useState(false);
  const handleSwitchChange = (props) => {
    setswitchCheck(!switchCheck);
  };

  const [serviceChargeCompulsoryCheck, setserviceChargeCompulsoryCheck] =
    useState(false);

  const handleServiceChargeCompulsoryCheck = (props) => {
    if (serviceChargeCompulsoryCheck == false) {
      setserviceChargeCompulsoryCheck(true);
    } else {
      setserviceChargeCompulsoryCheck(false);
    }
  };

  //#endregion

  useEffect(() => {
    console.log("ManagerDatas:", ManagerDatas);
    console.log("dataCollection employees:", dataCollection?.employees);
  }, [ManagerDatas, dataCollection]);

  useEffect(() => {
    if (
      ManagerDatas &&
      ManagerDatas.length > 0 &&
      dataCollection.employees &&
      dataCollection.employees.length > 0
    ) {
      // Map through all employees and find matching managers
      const selectedManagersList = dataCollection.employees
        .map((emp) => {
          // Find manager by ID and name since we now group by user ID
          const managerMatch = ManagerDatas.find(
            (m) => m.id === emp.id && m.title === emp.fullName,
          );
          return managerMatch || null;
        })
        .filter((manager) => manager !== null); // Remove null values

      setSelectedManagers(selectedManagersList);
      setOriginalManagers(selectedManagersList); // Store original managers for comparison
      console.log("Selected Managers:", selectedManagersList);
      console.log("dataCollection.employees:", dataCollection.employees);
      console.log(ManagerDatas);
    }
  }, [ManagerDatas, dataCollection]);

  return (
    <div>
      <ToastContainer />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"You want to edit this file?"}
        onyes={handleOnYes}
      />
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth={"xl"}
          open={restaurantModalOpen}
          // onClose={handleClose}
        >
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
            id={2}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Edit Restaurant</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent>
            <ToastContainer />
            <LoadingView open={loadingModal} close={closeLoadingModal} />
            <div style={{ padding: "10px" }}>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>Name</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    label={"Restaurant name"}
                    value={(props) => {
                      newRestaurant.Restaurantname = props;
                      setreestaurantName(props);
                    }}
                    val={reestaurantName}
                    defaultValue={newRestaurant.Restaurantname}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Url Name
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    label={" Url Name"}
                    val={newRestaurant.urlName}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid
                container
                sx={{ padding: "0.5rem" }}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid item xs={2}>
                  <Typography>Address Line 1</Typography>
                </Grid>
                <Grid item xs={8}>
                  {isLoaded ? (
                    // <GooglePlacesAutocomplete
                    //   onLoad={(autocomplete) => {
                    //     autocompleteRef.current = autocomplete;
                    //   }}
                    //   onPlaceChanged={() => {
                    //     const place = autocompleteRef.current?.getPlace();
                    //     const inputEl = inputRef.current;
                    //     console.log("Selected place:", place);
                    //     let addressText = "";
                    //     if (place?.formatted_address) {
                    //       addressText = place.formatted_address;
                    //     } else if (inputEl) {
                    //       // Fallback for manual typing / partial selection
                    //       addressText = inputEl.value;
                    //     }

                    //     if (addressText) {
                    //       setSelectedAddress(addressText);
                    //       setNewRestaurant((prev) => ({
                    //         ...prev,
                    //         AddressLine1: addressText.trim(),
                    //       }));
                    //     }

                    //     // Optional: auto-fill city/postcode
                    //     if (place?.address_components) {
                    //       const components = place.address_components;
                    //       const postcode = components.find((c) =>
                    //         c.types.includes("postal_code"),
                    //       )?.short_name;
                    //       const city = components.find((c) =>
                    //         c.types.includes("locality"),
                    //       )?.long_name;
                    //       if (postcode)
                    //         setNewRestaurant((prev) => ({
                    //           ...prev,
                    //           PostCode: postcode,
                    //         }));
                    //       if (city)
                    //         setNewRestaurant((prev) => ({
                    //           ...prev,
                    //           City: city,
                    //         }));
                    //     }
                    //   }}
                    //   options={{
                    //     types: ["address"],
                    //     componentRestrictions: { country: "gb" },
                    //     fields: [
                    //       "formatted_address",
                    //       "address_components",
                    //       "geometry",
                    //     ],
                    //   }}
                    // >
                    //   <TextField
                    //     inputRef={inputRef} // ✅ crucial: attach ref here
                    //     label="Address line 1"
                    //     variant="outlined"
                    //     fullWidth
                    //     value={selectedAddress}
                    //     onChange={(e) => setSelectedAddress(e.target.value)}
                    //     placeholder="Start typing an address..."
                    //   />
                    // </GooglePlacesAutocomplete>

                    <GooglePlacesAutocomplete
                      onLoad={(autocomplete) => {
                        autocompleteRef.current = autocomplete;
                      }}
                      onPlaceChanged={() => {
                        const place = autocompleteRef.current?.getPlace();

                        console.log("FULL PLACE:", JSON.stringify(place));

                        if (!place?.geometry) {
                          console.log("No geometry found");
                          return;
                        }

                        const lat = place.geometry.location.lat();
                        const lng = place.geometry.location.lng();

                        const components = place.address_components || [];

                        const postcode =
                          components.find((c) =>
                            c.types.includes("postal_code"),
                          )?.long_name || "";

                        const city =
                          components.find((c) => c.types.includes("locality"))
                            ?.long_name ||
                          components.find((c) =>
                            c.types.includes("postal_town"),
                          )?.long_name ||
                          "";

                        setSelectedAddress(place.formatted_address || "");

                        setNewRestaurant((prev) => ({
                          ...prev,
                          AddressLine1: place.formatted_address || "",
                          PostCode: postcode,
                          City: city,
                          Latitude: lat,
                          Longitude: lng,
                        }));
                      }}
                      fields={[
                        "formatted_address",
                        "geometry",
                        "address_components",
                      ]}
                      options={{
                        types: ["address"],
                        componentRestrictions: { country: "gb" },
                      }}
                    >
                      <TextField
                        inputRef={inputRef}
                        label="Address line 1"
                        variant="outlined"
                        fullWidth
                        value={selectedAddress}
                        onChange={(e) => setSelectedAddress(e.target.value)}
                        placeholder="Start typing an address..."
                      />
                    </GooglePlacesAutocomplete>
                  ) : (
                    <TextField
                      label="Address line 1"
                      variant="outlined"
                      fullWidth
                      value={selectedAddress}
                      onChange={(e) => setSelectedAddress(e.target.value)}
                      InputProps={{
                        endAdornment: <CircularProgress size={20} />,
                      }}
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "5px",
                  }}
                >
                  <Button
                    className="AddItemButtons"
                    onClick={handleOpenAddressModal}
                  >
                    Edit
                  </Button>
                </Grid>
              </Grid>

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Address line 2 (optional)
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    label={"Address line 2 (optional)"}
                    value={(props) => {
                      setAddressLine2(props);
                      newRestaurant.AddressLine2 = props;
                    }}
                    val={newRestaurant.AddressLine2}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              {/* City Field */}
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>City</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    label={"City"}
                    value={(props) => {
                      SetCity(props);
                      newRestaurant.City = props;
                    }}
                    val={newRestaurant.City}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Post Code
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    label={"Post Code"}
                    // value={(props) => {
                    //   newRestaurant.PostCode = props;
                    // }}
                    value={(props) => {
                      setNewRestaurant((prev) => ({
                        ...prev,
                        PostCode: props,
                      }));
                    }}
                    val={newRestaurant.PostCode}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Email Address
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    label={"Email Address"}
                    value={(props) => {
                      newRestaurant.Email = props;
                      setEmail(props);
                    }}
                    val={email}
                    error={emailErr}
                    isValid={isvalidEmail}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Phone Number
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    label={"Phone Number"}
                    value={phoneNumberValue}
                    id="3"
                    val={phoneNumber}
                  ></TextAreaComponents>
                  <span
                    className={`${validPhoneNumber ? "d-none" : ""}`}
                    style={{ color: "red" }}
                  >
                    Phone Number is not valid
                  </span>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Provided Food Category
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  {sectionDatas.length > 0 &&
                  dataCollection.foodcategories != undefined ? (
                    <AutoCompleteMultiSelect
                      label={"Type Of Restaurant"}
                      placeholder={"Type Of Restaurant"}
                      value={addProvidedFoodValue}
                      datas={sectionDatas}
                      defaultValue={getDefaultValur()}
                    />
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid
                  item
                  xs={1}
                  className="AddItemplusIcon"
                  onClick={() => setOpenAddSection(true)}
                >
                  <img src={plusIcon} alt="+" />
                </Grid>
                <AddFoodCategoryDialog
                  open={openAddSection}
                  dialogType={"Add New Category"}
                  onHandleAddItem={handleOpenFoodCategory}
                  isSubmitting={isSubmitting}
                  setIsSubmitting={setIsSubmitting}
                  onClose={() => {
                    loadData();
                  }}
                />
              </Grid>
              {/* <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Is member of a chain?
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Switch
                                        checked={isChain}
                                        onChange={() => { setisChain(!isChain) }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Grid>
                            </Grid> */}
              {/* {isChain && (
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={9}>

                                    </Grid>

                                    <Grid item xs={1} className="AddItemplusIcon">
                                        <img src={plusIcon} alt="+" onClick={() => { setOpen(true) }} />
                                    </Grid>
                                </Grid>
                             )}  */}
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Details
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    id={1}
                    label={"Details"}
                    value={(props) => {
                      newRestaurant.Details = props;
                      setDetails(props);
                    }}
                    val={details}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <SchedulerComponent
                    from="discount"
                    getSchedule={getSchedule}
                    isEdit={"true"}
                    selectedItem={dataCollection.schedulers}
                    getLastOrderTimeList={getLastOrderTime}
                    showSchedulerTable={true}
                    showLastOrderTime={true}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Local Manager
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <div className="d-flex w-100" style={{ gap: "10px" }}>
                    <div className="" style={{ width: "60rem" }}>
                      {(() => {
                        if (ManagerDatas && ManagerDatas.length > 0) {
                          return (
                            <Autocomplete
                              multiple
                              options={ManagerDatas}
                              getOptionLabel={(option) => option?.title || ""}
                              value={selectedManagers}
                              onChange={handleManagerSelectionChange}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Manager Name"
                                  placeholder="Manager Name"
                                  variant="outlined"
                                />
                              )}
                              isOptionEqualToValue={(option, value) =>
                                option?.id === value?.id
                              }
                              id="manager-autocomplete"
                              renderOption={(props, option) => (
                                <Box
                                  component="li"
                                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                  {...props}
                                >
                                  <img
                                    loading="lazy"
                                    src={img1}
                                    alt=""
                                    style={{ width: "2rem" }}
                                  />
                                  <div
                                    className="d-flex "
                                    style={{ flexDirection: "column" }}
                                  >
                                    <div
                                      className="d-flex"
                                      style={{
                                        gap: "10px",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <h5
                                        className="mb-0"
                                        style={{ margin: 0 }}
                                      >
                                        {option.title}
                                      </h5>
                                      {option.roles &&
                                        option.roles.map((role, index) => (
                                          <React.Fragment key={index}>
                                            <div
                                              style={{
                                                backgroundColor: "#fde6ea",
                                                padding: "5px",
                                                fontSize: ".8rem",
                                                borderRadius: "10px",
                                                color: "#847c7d",
                                              }}
                                            >
                                              {role}
                                            </div>
                                            {index <
                                              option.roles.length - 1 && (
                                              <span
                                                style={{
                                                  color: "#847c7d",
                                                  fontSize: ".8rem",
                                                }}
                                              >
                                                |
                                              </span>
                                            )}
                                          </React.Fragment>
                                        ))}
                                    </div>
                                    <span
                                      className="text-muted"
                                      style={{
                                        fontSize: "1rem",
                                        marginTop: "0",
                                      }}
                                    >
                                      {option.restaurant}
                                    </span>
                                  </div>
                                </Box>
                              )}
                            />
                          );
                        } else {
                          return (
                            <Autocomplete
                              options={ManagerDatas}
                              getOptionLabel={(option) => option.title || ""}
                              value={selectedManagers}
                              onChange={handleManagerSelectionChange}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Manager Name"
                                  placeholder="Manager Name"
                                  variant="outlined"
                                />
                              )}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              id="manager-autocomplete"
                              renderOption={(props, option) => (
                                <Box
                                  component="li"
                                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                  {...props}
                                >
                                  <img
                                    loading="lazy"
                                    src={img1}
                                    alt=""
                                    style={{ width: "2rem" }}
                                  />
                                  <div
                                    className="d-flex "
                                    style={{ flexDirection: "column" }}
                                  >
                                    <div
                                      className="d-flex"
                                      style={{
                                        gap: "10px",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <h5
                                        className="mb-0"
                                        style={{ margin: 0 }}
                                      >
                                        {option.title}
                                      </h5>
                                      {option.roles &&
                                        option.roles.map((role, index) => (
                                          <React.Fragment key={index}>
                                            <div
                                              style={{
                                                backgroundColor: "#fde6ea",
                                                padding: "5px",
                                                fontSize: ".8rem",
                                                borderRadius: "10px",
                                                color: "#847c7d",
                                              }}
                                            >
                                              {role}
                                            </div>
                                            {index <
                                              option.roles.length - 1 && (
                                              <span
                                                style={{
                                                  color: "#847c7d",
                                                  fontSize: ".8rem",
                                                }}
                                              >
                                                |
                                              </span>
                                            )}
                                          </React.Fragment>
                                        ))}
                                    </div>
                                    <span
                                      className="text-muted"
                                      style={{
                                        fontSize: "1rem",
                                        marginTop: "0",
                                      }}
                                    >
                                      {option.restaurant}
                                    </span>
                                  </div>
                                </Box>
                              )}
                            />
                          );
                        }
                      })()}
                    </div>
                    <button
                      className="btn modalAddButton"
                      onClick={() => {
                        handleOpen();
                      }}
                    >
                      +Add Employee
                    </button>
                  </div>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>Logo</Typography>
                </Grid>
                <Grid xs={9}>
                  <Button
                    variant="contained"
                    component="label"
                    //   color="primary"
                    className="uploadButton"
                    // style={{ backgroundColor: 'white', color: 'gray' }}
                  >
                    <img
                      src={galleryIcon}
                      alt="photo"
                      // style={{ width: '2rem' }}
                    />
                    Upload
                    <input
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                      onChange={handleImageUpload}
                      disabled={state.selectedImages.length >= 1}
                    />
                  </Button>
                </Grid>

                {/* image show start */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={9}>
                    <Grid container spacing={2}>
                      {state.selectedImages.map((image, index) => (
                        <Grid item xs={2} sm={2} md={2} key={index}>
                          {/* <Paper> */}
                          <div
                            style={{
                              position: "relative",
                              paddingTop: "20px",
                            }}
                          >
                            <img
                              src={image}
                              alt={`Preview ${index + 1}`}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <IconButton
                              style={{
                                position: "absolute",
                                top: "-6px",
                                right: "-23px",
                                color: "gray",
                              }}
                              onClick={() => handleDeleteImage(index)}
                            >
                              <CancelIcon />
                            </IconButton>
                          </div>
                          {/* </Paper> */}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
                {/* image show end */}
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Background Image
                  </Typography>
                </Grid>
                <Grid xs={9}>
                  <Button
                    variant="contained"
                    component="label"
                    //   color="primary"
                    className="uploadButton"
                    // style={{ backgroundColor: 'white', color: 'gray' }}
                  >
                    <img
                      src={galleryIcon}
                      alt="photo"
                      // style={{ width: '2rem' }}
                    />
                    Upload
                    <input
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                      onChange={handleBackgroundImageUpload}
                      disabled={BackgroundImagestate.selectedImages.length >= 1}
                    />
                  </Button>
                </Grid>

                {/* image show start */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={9}>
                    <Grid container spacing={2}>
                      {BackgroundImagestate.selectedImages.map(
                        (image, index) => (
                          <Grid item xs={2} sm={2} md={2} key={index}>
                            {/* <Paper> */}
                            <div
                              style={{
                                position: "relative",
                                paddingTop: "20px",
                              }}
                            >
                              <img
                                src={image}
                                alt={`Preview ${index + 1}`}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <IconButton
                                style={{
                                  position: "absolute",
                                  top: "-6px",
                                  right: "-23px",
                                  color: "gray",
                                }}
                                onClick={() =>
                                  handleBackgroundDeleteImage(index)
                                }
                              >
                                <CancelIcon />
                              </IconButton>
                            </div>
                            {/* </Paper> */}
                          </Grid>
                        ),
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                {/* image show end */}
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Premises Image
                  </Typography>
                </Grid>
                <Grid xs={9}>
                  <Button
                    variant="contained"
                    component="label"
                    //   color="primary"
                    className="uploadButton"
                    // style={{ backgroundColor: 'white', color: 'gray' }}
                  >
                    <img
                      src={galleryIcon}
                      alt="photo"
                      // style={{ width: '2rem' }}
                    />
                    Upload
                    <input
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                      onChange={handlePremisesImageUpload}
                      disabled={PremisesImagestate.selectedImages.length >= 5}
                    />
                  </Button>
                </Grid>

                {/* image show start */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={9}>
                    <Grid container spacing={2}>
                      {PremisesImagestate.selectedImages.map((image, index) => (
                        <Grid item xs={2} sm={2} md={2} key={index}>
                          {/* <Paper> */}
                          <div
                            style={{
                              position: "relative",
                              paddingTop: "20px",
                            }}
                          >
                            <img
                              src={image}
                              alt={`Preview ${index + 1}`}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <IconButton
                              style={{
                                position: "absolute",
                                top: "-6px",
                                right: "-23px",
                                color: "gray",
                              }}
                              onClick={() => handlePremisesDeleteImage(index)}
                            >
                              <CancelIcon />
                            </IconButton>
                          </div>
                          {/* </Paper> */}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
                {/* image show end */}
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Service Charge
                  </Typography>
                </Grid>
                <Grid item xs={9.5}>
                  <TextAreaComponents
                    id={2}
                    label={"Service Charge (In Amount)"}
                    value={(props) => {
                      newRestaurant.ServiceCahrge = props;
                      setserviceCharge(props);
                    }}
                    val={serviceCharge}
                  />
                </Grid>
                <Grid item xs={0.5} sx={{ padding: "0.5rem" }}>
                  <Checkbox
                    checked={serviceChargeCompulsoryCheck}
                    onChange={handleServiceChargeCompulsoryCheck}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Hygiene rating (Out of 10)
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextAreaComponents
                    id={3}
                    label={"Hygiene rating (Out of 10)"}
                    value={(props) => {
                      if (props > 10 || props < 0) {
                        newRestaurant.HygeneRating = 1;
                        setHygieneRating(1);
                        toast.error(
                          "Hygiene rating should be less then 10 or greater then 1",
                          {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          },
                        );
                      } else {
                        newRestaurant.HygeneRating = props;
                        setHygieneRating(props);
                      }
                    }}
                    min={1}
                    max={10}
                    val={hygieneRating}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Is Pet Friendly
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Switch
                    checked={switchCheck}
                    onChange={handleSwitchChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
              </Grid>

              {/* delivery toggle button */}
              {isHomeCookToggle ? (
                isPreviewMode ? (
                  // in preview mode: delivery toggle off & disable
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}>
                      <Typography style={{ paddingTop: "1rem" }}>
                        Delivery
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Grid item xs={12}>
                        <Switch
                          checked={false}
                          disabled={true}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : subscriptionPlan === "Basic Collection" ? (
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}>
                      <Typography style={{ paddingTop: "1rem" }}>
                        Delivery
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Grid item xs={12}>
                        <Switch
                          checked={true}
                          disabled={true}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </Grid>

                      <Grid
                        container
                        spacing={2}
                        sx={{ padding: "0.5rem", alignItems: "center" }}
                      >
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography
                            fontSize={14}
                            style={{ marginRight: "1rem" }}
                          >
                            TAKEAWAY RESTAURANT
                          </Typography>
                          <Switch
                            checked={true}
                            disabled={true}
                            inputProps={{
                              "aria-label": "Takeaway Restaurant Switch",
                            }}
                            size="small"
                          />
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography
                            fontSize={14}
                            style={{ marginRight: "1rem" }}
                          >
                            COLLECTION ONLY
                          </Typography>
                          <Switch
                            checked={true}
                            disabled={true}
                            inputProps={{
                              "aria-label": "Collection Only Switch",
                            }}
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}>
                      <Typography style={{ paddingTop: "1rem" }}>
                        Delivery
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Grid item xs={12}>
                        <Switch
                          checked={DeliveryswitchCheck}
                          onChange={handleDeliverySwitchChange}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </Grid>

                      {DeliveryswitchCheck && (
                        <Grid
                          container
                          spacing={2}
                          sx={{ padding: "0.5rem", alignItems: "center" }}
                        >
                          <Grid
                            item
                            xs={2}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Typography
                              fontSize={14}
                              style={{ marginRight: "1rem" }}
                            >
                              TAKEAWAY RESTAURANT
                            </Typography>
                            <Switch
                              checked={DeliveryOnlyswitchCheck}
                              onChange={handleDeliveryOnlySwitchChange}
                              inputProps={{
                                "aria-label": "Takeaway Restaurant Switch",
                              }}
                              size="small"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Typography
                              fontSize={14}
                              style={{ marginRight: "1rem" }}
                            >
                              COLLECTION ONLY
                            </Typography>
                            <Switch
                              checked={CollectionswitchCheck}
                              onChange={handleCollectionSwitchChange}
                              inputProps={{
                                "aria-label": "Collection Only Switch",
                              }}
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                )
              ) : (
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Delivery
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid item xs={12}>
                      <Switch
                        checked={DeliveryswitchCheck}
                        onChange={handleDeliverySwitchChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>

                    {DeliveryswitchCheck && (
                      <Grid
                        container
                        spacing={2}
                        sx={{ padding: "0.5rem", alignItems: "center" }}
                      >
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography
                            fontSize={14}
                            style={{ marginRight: "1rem" }}
                          >
                            TAKEAWAY RESTAURANT
                          </Typography>
                          <Switch
                            checked={DeliveryOnlyswitchCheck}
                            onChange={handleDeliveryOnlySwitchChange}
                            inputProps={{
                              "aria-label": "Takeaway Restaurant Switch",
                            }}
                            size="small"
                          />
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography
                            fontSize={14}
                            style={{ marginRight: "1rem" }}
                          >
                            COLLECTION ONLY
                          </Typography>
                          <Switch
                            checked={CollectionswitchCheck}
                            onChange={handleCollectionSwitchChange}
                            inputProps={{
                              "aria-label": "Collection Only Switch",
                            }}
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Wifi Details
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid item xs={12}>
                    <Switch
                      checked={wifiCheck}
                      onClick={handleWifiCheck}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Grid>

                  {wifiCheck && (
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography
                          fontSize={14}
                          style={{ paddingTop: "0.2rem" }}
                        >
                          Set Wifi As Public
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Switch
                          checked={wifiPublicCheck}
                          onChange={handleWifiPublicCheck}
                          inputProps={{ "aria-label": "controlled" }}
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                        <TextField
                          fullWidth
                          id="outlined"
                          label="Network"
                          onChange={(e) => setwifiSSID(e.target.value)}
                          value={wifiSSID}
                          autoComplete="off"
                          defaultValue={wifiSSID}
                        />
                      </Grid>
                      {!wifiPublicCheck && (
                        <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                          <FormControl
                            sx={{ width: "100%" }}
                            variant="outlined"
                          >
                            <InputLabel htmlFor="outlined-adornment-password">
                              Password
                            </InputLabel>
                            <OutlinedInput
                              id="outlined-adornment-password"
                              value={wifiPassWord}
                              onChange={(e) => setwifiPassWord(e.target.value)}
                              type={showPassword ? "text" : "password"}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label={
                                      showPassword
                                        ? "hide the password"
                                        : "display the password"
                                    }
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    onMouseUp={handleMouseUpPassword}
                                    edge="end"
                                  >
                                    {showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                              label="Password"
                              autoComplete="new-password"
                            />
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {/* Web Link Field */}
              <Grid container sx={{ padding: "0.5rem" }}>
                {/* label */}
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Web Link
                  </Typography>
                </Grid>

                <Grid item xs={10}>
                  <Grid container sx={{}}>
                    {/* inputField */}
                    <Grid item xs={10}>
                      <TextAreaComponents
                        label={"example: 'zyz.com' || 'abc.org'"}
                        value={(props) => {
                          SetWebLink(props);
                        }}
                        val={webLink}
                      />
                    </Grid>

                    {/* AddButton */}
                    <Grid item xs={2}>
                      <div className="d-flex h-100 ms-2">
                        <Button
                          className="AddItemButtons"
                          onClick={() => {
                            addWebLink();
                          }}
                        >
                          Add
                        </Button>
                      </div>
                    </Grid>

                    <Grid item xs={12} className="mt-3">
                      {webLinkList.length > 0 ? (
                        <RestaurantTable
                          lists={webLinkList}
                          getTypeWriterData={getWebLinkData}
                          from={"edit"}
                        />
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Spotify Link Field */}
              <Grid container sx={{ padding: "0.5rem" }}>
                {/* label */}
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Spotify Playlist Link
                  </Typography>
                </Grid>

                <Grid item xs={10}>
                  <Grid container sx={{}}>
                    {/* inputField */}
                    <Grid item xs={10}>
                      <TextAreaComponents
                        label={"Spotify Playlist Link"}
                        value={(props) => {
                          SetspotifyLink(props);
                        }}
                        val={spotifyLink}
                      />
                    </Grid>

                    {/* AddButton */}
                    <Grid item xs={2}>
                      <div className="d-flex h-100 ms-2">
                        <Button
                          className="AddItemButtons"
                          onClick={() => {
                            addtoSpotifyLinksList();
                          }}
                        >
                          Add
                        </Button>
                      </div>
                    </Grid>

                    <Grid item xs={12} className="mt-3">
                      {spotifyLinkList?.length > 0 ? (
                        <RestaurantTable
                          lists={spotifyLinkList}
                          getTypeWriterData={getSpotifyData}
                          from={"edit"}
                        />
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{}}>Animated Cover photo text:</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Grid container sx={{}}>
                    <Grid item xs={10}>
                      <TextAreaComponents
                        label={"Text"}
                        value={(props) => {
                          SettypewriterText(props);
                        }}
                        val={typewriterText}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <div className="d-flex h-100 ms-2">
                        <Button
                          className="AddItemButtons"
                          onClick={() => {
                            addtoTypewriterList();
                          }}
                        >
                          Add
                        </Button>
                      </div>
                    </Grid>
                    <Grid item xs={12} className="mt-3">
                      {typewriterTextList.length > 0 ? (
                        <RestaurantTable
                          lists={typewriterTextList}
                          getTypeWriterData={getTypeWriterData}
                          from={"edit"}
                          editData={editRow}
                          deleteRow={deleteRow}
                        />
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Update Button */}
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={10}></Grid>
                <Grid item xs={2}>
                  <Button
                    className="AddItemButtons"
                    onClick={() => {
                      postData();
                    }}
                  >
                    Update
                  </Button>
                </Grid>
              </Grid>
            </div>
          </DialogContent>

          <AddEmpDialog
            open={open}
            onHandleAddItem={handleAddItem}
            title={props.title}
          ></AddEmpDialog>
        </Dialog>
      </React.Fragment>
      <AddressAddModal
        showModal={showAddressModal}
        handleClose={handleCloseAddressModal}
        changeAddress={handleAddressSelect}
        initialAddress={
          newRestaurant.AddressLine1
            ? {
                address: newRestaurant.AddressLine1,
                // latitude: newRestaurant.Latitude,
                // longitude: newRestaurant.Longitude
              }
            : null
        }
      />
    </div>
  );
}

export default EditEmployeeDialog;
